import clsx from "clsx";
import React, {
  Children,
  ReactElement,
  ReactNode,
  isValidElement,
} from "react";

import s from "../EmployeeProfileView.less";

interface IDataRowProps {
  label: string;
  children: ReactNode;
  striped?: boolean;
  personal?: boolean;
  compact?: boolean;
  alignTop?: boolean;
  valueClassName?: string;
}

export const DataRow = ({
  label,
  children,
  striped = false,
  personal = false,
  compact = false,
  alignTop = false,
  valueClassName,
}: IDataRowProps) => (
  <div
    className={s.dataRow}
    data-striped={striped ? "true" : "false"}
    data-personal={personal ? "true" : "false"}
    data-align-top={alignTop ? "true" : "false"}
  >
    <span
      className={personal ? s.labelPersonal : compact ? s.labelCompact : s.label}
    >
      {label}
    </span>
    <div className={clsx(s.value, valueClassName)}>{children}</div>
  </div>
);

interface IDataRowsProps {
  children: ReactNode;
  personal?: boolean;
}

const flattenChildren = (children: ReactNode): ReactElement<IDataRowProps>[] => {
  const result: ReactElement<IDataRowProps>[] = [];

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }

    if (child.type === React.Fragment) {
      flattenChildren(child.props.children).forEach((item) => result.push(item));
      return;
    }

    result.push(child as ReactElement<IDataRowProps>);
  });

  return result;
};

export const DataRows = ({ children, personal = false }: IDataRowsProps) => {
  const rows = flattenChildren(children);

  return (
    <div className={personal ? s.dataRowsPersonal : s.dataRows}>
      {rows.map((child, index) =>
        React.cloneElement(child, { striped: index % 2 === 0, personal }),
      )}
    </div>
  );
};
